// this file ist responsible for handling consequence table related actions.
import*as actionTypes from'./actionTypes';// sets the dirty flag
export var loadCtData=function loadCtData(data){return{type:actionTypes.CT_LOAD_DATA,data:data};};export var editCtData=function editCtData(data){return{type:actionTypes.CT_EDIT_DATA,data:data};};export var setCtUser=function setCtUser(user){return{type:actionTypes.CT_SET_USER,user:user};};export var clearCtData=function clearCtData(){return{type:actionTypes.CT_CLEAR};};export var setSelectedAlt=function setSelectedAlt(selectedAlt){return{type:actionTypes.CT_SELECT_ALT,selectedAlt:selectedAlt};};


//////////////////
// WEBPACK FOOTER
// ./src/store/actions/consequenceTable.js
// module id = 771
// module chunks = 29